import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-effa74ae")

_pushScopeId("data-v-effa74ae")
const _hoisted_1 = { class: "tripTable" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "tripTable__header" }, [
  /*#__PURE__*/_createVNode("h2", null, "Остальное")
], -1)
const _hoisted_3 = { class: "tripTable__table" }
const _hoisted_4 = /*#__PURE__*/_createVNode("th", { class: "col1" }, " Тип ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Id ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "wrapico" }, [
  /*#__PURE__*/_createVNode("div", { class: "upIco" }),
  /*#__PURE__*/_createVNode("div", { class: "downIco" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Дата создания ")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "wrapico" }, [
  /*#__PURE__*/_createVNode("div", { class: "upIco" }),
  /*#__PURE__*/_createVNode("div", { class: "downIco" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Компания ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "wrapico" }, [
  /*#__PURE__*/_createVNode("div", { class: "upIco" }),
  /*#__PURE__*/_createVNode("div", { class: "downIco" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Название ")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "wrapico" }, [
  /*#__PURE__*/_createVNode("div", { class: "upIco" }),
  /*#__PURE__*/_createVNode("div", { class: "downIco" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("th", { class: "col7" }, null, -1)
const _hoisted_14 = {
  colspan: "7",
  class: "clearTd"
}
const _hoisted_15 = { class: "clearTable" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrderElement = _resolveComponent("OrderElement")
  const _component_OrderDetails = _resolveComponent("OrderDetails")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("table", null, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            _hoisted_4,
            _createVNode("th", {
              class: ["col2 sort", _ctx.getSortClass(_ctx.SORTING_FIELDS.ID)],
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.sort(_ctx.SORTING_FIELDS.ID)))
            }, [
              _hoisted_5,
              _hoisted_6
            ], 2),
            _createVNode("th", {
              class: ["col3 sort", _ctx.getSortClass(_ctx.SORTING_FIELDS.DATE)],
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.sort(_ctx.SORTING_FIELDS.DATE)))
            }, [
              _hoisted_7,
              _hoisted_8
            ], 2),
            _createVNode("th", {
              class: ["col4 sort", _ctx.getSortClass(_ctx.SORTING_FIELDS.CLIENT)],
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.sort(_ctx.SORTING_FIELDS.CLIENT)))
            }, [
              _hoisted_9,
              _hoisted_10
            ], 2),
            _createVNode("th", {
              class: ["col5 sort", _ctx.getSortClass(_ctx.SORTING_FIELDS.NAME)],
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.sort(_ctx.SORTING_FIELDS.NAME)))
            }, [
              _hoisted_11,
              _hoisted_12
            ], 2),
            _hoisted_13
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tripList, (item) => {
            return (_openBlock(), _createBlock("tr", {
              key: item.businessTripId,
              class: "clearTd"
            }, [
              _createVNode("td", _hoisted_14, [
                _createVNode("table", _hoisted_15, [
                  _createVNode(_component_OrderElement, {
                    item: item,
                    toggleFun: _ctx.toggleFun,
                    isOpen: _ctx.activeOrder === item.businessTripId
                  }, null, 8, ["item", "toggleFun", "isOpen"]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withId(() => [
                      (_ctx.activeOrder === item.businessTripId && _ctx.listOrders)
                        ? (_openBlock(), _createBlock(_component_OrderDetails, {
                            key: 0,
                            tickets: _ctx.tickets,
                            tripId: item.businessTripId
                          }, null, 8, ["tickets", "tripId"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
})